import { ContactDetails } from '../../../types/ambassador/bookings/ambassador-bookings-v2-booking';
import { FormApiContext } from '../utils';
import { splitFullName } from '../../../utils/nameParser';

export type MapContactDetailsArgs = {
  contactDetails: ContactDetails;
};

export const mapContactDetails = ({
  contactDetails,
}: MapContactDetailsArgs & FormApiContext): ContactDetails => {
  if (!isPhoneValid(contactDetails.phone!)) {
    delete contactDetails.phone;
  }

  const { firstName, lastName } = splitFullName({
    firstName: contactDetails?.firstName || undefined,
    lastName: contactDetails?.lastName || undefined,
  });

  return {
    ...contactDetails,
    ...(firstName && ({ firstName } as { firstName: string | undefined })),
    ...(lastName && ({ lastName } as { lastName: string | undefined })),
  };
};

const isPhoneValid = (phone: string): boolean => {
  if (!phone) {
    return false;
  }
  const phoneValidatorRegEx = /^[\d\s+\-().]+$/;
  return (phone.match(phoneValidatorRegEx)?.length || 0) > 0;
};
